export default "__VITE_ASSET__CPWMr8YP__"